import { render, staticRenderFns } from "./CidadeAdicionar.vue?vue&type=template&id=3a8e5d2a"
import script from "./CidadeAdicionar.vue?vue&type=script&lang=js"
export * from "./CidadeAdicionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports